<template>
  <div>
    <section-wrapper>
      <div class="olympic active">
        <section class="olympic__header">
          <div class="olympic__header__text">
            <h1 class="text-danger">ВСЕРОССИЙСКАЯ ОЛИМПИАДА</h1>
            <h1 class="mt-2 content_60">«КАДРЫ ДЛЯ ЭКСПОРТА»</h1>
            <h2 class="mt-2 text-primary">Проверь себя в ВЭД и получи возможности для карьерного развития</h2>
          </div>
          <div class="d-none d-lg-block olympic__header__img">
            <img title="Всероссийская олимпиада «Кадры для экспорта»" src="/pic/owl.png" />
          </div>
        </section>
        <section class="olympic__text mb-5">
          <h1 class="text-dark mb-2">Об Олимпиаде</h1>
          <p class="content_22 mb-2"><b>Олимпиада «Кадры для экспорта»</b> — это образовательное соревнование, которое помогает молодежи проверить свои знания в сфере внешнеэкономической деятельности. Участники смогут не только продемонстрировать свои знания и навыки, но и получить поддержку для дальнейшего профессионального развития!</p>
          <p class="content_22 mb-2">В 2026 году Олимпиада реализуется для трех аудиторий: школьники, студенты и молодые специалисты.</p>
          <p class="content_22 mb-2">Дата окончания регистрации: <b>29 октября</b> до 18:00 по мск</p>
          <p class="content_22 mb-2">Единый день проведения Олимпиады: <b>30 октября</b> (00:00-23:59 по мск)</p>
        </section>
        <section class="olympic__text mb-5">
          <h1 class="text-dark mb-2">Участие в Олимпиаде — это возможность:</h1>
          <ul class="content_22 mb-2">
            <li>Проверить свои знания по ВЭД в интерактивном формате</li>
            <li>Получить сертификат участника</li>
            <li>Попасть в сообщество молодежи, заинтересованных в международной торговле</li>
            <li>Получить обратную связь от эксперта (доступно для финалистов на уровне для студентов и молодых специалистов)</li>
          </ul>
        </section>
        <section ref="tracks" class="olympic__text mb-5">
          <div class="container-grid grid-2 grid-md-1">
            <div class="container-grid__item">
              <div class="container-shadow p-24 fill-white d-flex flex-column">
                <h2 class="mb-2">Трек «Старт»</h2>
                <p class="content_22 content_700 mb-3">Для школьников 8–11 классов</p>
                <p class="content_18 content_700 mb-2">Расписание:</p>
                <ul class="list list_dotted content_18 mb-3">
                  <li><b>До 29 октября.</b> Регистрация + доступ к экспертному чату для прокачки навыков</li>
                  <li><b>30 октября.</b> Прохождение заданий Олимпиады (в любое время с 00:00 до 23:59 по мск)</li>
                  <li><b>Ноябрь.</b> Оглашение результатов и выдача сертификатов участникам</li>
                </ul>
                <p class="content_22 mb-3">Проверь свои знания, получи сертификат и забери крутые подарки от Школы экспорта РЭЦ (доступно для победителей)</p>
                <div class="notice notice_red mb-3">
                  <div class="notice__content">
                    <p>Чтобы мы могли принять вашу заявку, нам нужно согласие родителей. Пожалуйста, скачайте бланк ниже, заполните его и загрузите подписанный скан в форму по кнопке ниже</p>
                    <a :href="consentBlankUrl" target="_blank" rel="noopener" class="content_red content_underline">Бланк согласия родителя</a>
                  </div>
                </div>
                <div class="mt-auto">
                  <button v-if="registrationOpen" @click="openRegistration('junior')" class="link-target"><span>Зарегистрироваться</span></button>
                  <button v-else @click="openStart" class="link-target"><span>Перейти к заданиям</span></button>
                </div>
              </div>
            </div>
            <div class="container-grid__item">
              <div class="container-shadow p-24 fill-white d-flex flex-column">
                <h2 class="mb-2">Трек «Профи»</h2>
                <p class="content_22 content_700 mb-3">Для студентов старших курсов и молодых специалистов</p>
                <p class="content_18 content_700 mb-2">Расписание:</p>
                <ul class="list list_dotted content_18 mb-3">
                  <li><b>До 29 октября.</b> Регистрация + доступ к экспертному чату для прокачки навыков</li>
                  <li><b>30 октября.</b> Прохождение заданий Олимпиады (в любое время с 00:00 до 23:59 по мск)</li>
                  <li><b>Ноябрь.</b> Оглашение результатов и выдача сертификатов участникам</li>
                </ul>
                <p class="content_18 content_700 mb-2">Эксклюзив для лидеров (ТОП-10): участие в кейс-этапе с профильной обратной связью</p>
                <ul class="list list_dotted content_18 mb-3">
                  <li>Карта уровня навыков с обратной связью по развитию</li>
                  <li>Рекомендательное письмо для будущих работодателей</li>
                </ul>
                <p class="content_22 mb-3">Подтверди свои компетенции, получи сертификат и подарки от Школы экспорта РЭЦ (доступно для победителей)</p>
                <div class="mt-auto">
                  <button v-if="registrationOpen" @click="openRegistration('pro')" class="link-target"><span>Зарегистрироваться</span></button>
                  <button v-else @click="openStart" class="link-target"><span>Перейти к заданиям</span></button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="olympic__text mb-5">
          <h1 class="text-dark mb-2">Документы</h1>
          <div class="container-grid grid-2 grid-md-1">
            <document title="Регламент Олимпиады" :link="reglamentUrl" />
            <document title="Согласие на обработку персональных данных" :link="pdConsentUrl" />
          </div>
        </section>
      </div>

      <!-- Модальные окна -->
      <olympics-cancel-confirm-modal
          v-model="showCancelConfirmModal"
          @yes="onCancelConfirmYes"
          @no="onCancelConfirmNo"
      />

      <olympics-registration-form
          v-model="showRegistrationForm"
          :track="selectedTrack"
          :consent-blank-url="consentBlankUrl"
          :reglament-url="reglamentUrl"
          :pd-consent-url="pdConsentUrl"
          @cancel="onRegistrationCancel"
          @success="onRegistrationSuccess"
      />

      <div v-if="showSuccessModal" class="modal olympic-modal letter fade show" style="display: block;" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <div class="title-with-icon">
                <div class="title-with-icon__icon title-with-icon__icon_login"></div>
                <div class="title-with-icon__title">
                  <span rel="letter" class="title-letter">Вам письмо!</span>
                </div>
              </div>
              <button type="button" class="close modal-close" @click="onSuccessOk" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <success-letter :email="successEmail" :title="successTitle" />
            </div>
          </div>
        </div>
      </div>
      <div v-if="showSuccessModal" class="modal-backdrop show"></div>

      <olympics-start-modal
          v-model="showStartModal"
          :loading="startLoading"
          :state="startState"
          :registration-open="registrationOpen"
          @login="onStartLogin"
          @register="onStartRegister"
      />
    </section-wrapper>
    <page-footer/>
  </div>
</template>

<script>
import SectionWrapper from "@/components/SectionWrapper.vue";
import OlympicsCancelConfirmModal from "@/components/olympics/OlympicsCancelConfirmModal.vue";
import OlympicsRegistrationForm from "@/components/olympics/OlympicsRegistrationForm.vue";
import OlympicsStartModal from "@/components/olympics/OlympicsStartModal.vue";
import SuccessLetter from "@/components/SuccessLetter.vue";
import ApiService from "../../services/api.service";
import PageFooter from "@/components/PageFooter.vue";
import Document from "@/components/Document.vue";

export default {
  name: "Olympics",
  components: {
    Document,
    PageFooter,
    SectionWrapper,
    OlympicsCancelConfirmModal,
    OlympicsRegistrationForm,
    OlympicsStartModal,
    SuccessLetter
  },
  data() {
    return {
      // Окончание регистрации по Москве, п. 5.2 Регламента (как OlympicsRegistration::REGISTRATION_END на бэкенде)
      registrationEnd: new Date('2026-10-29T18:00:00+03:00'),
      consentBlankUrl: '/docs/olympics-parent-consent.docx',
      reglamentUrl: '/docs/olympics-reglament-2026.pdf',
      pdConsentUrl: '/docs/olympics-pd-consent-2026.pdf',
      selectedTrack: null,
      showCancelConfirmModal: false,
      showRegistrationForm: false,
      showSuccessModal: false,
      successEmail: null,
      successTitle: '',
      // Стартовый экран прохождения (ссылка /olympics?step=start из чатов участников)
      showStartModal: false,
      startLoading: false,
      startState: null
    }
  },
  mounted() {
    this.$parent.init()
    this.checkStartMode()
  },
  computed: {
    registrationOpen() {
      return new Date() <= this.registrationEnd
    }
  },
  methods: {
    openRegistration(track) {
      // Трек выбирается только кнопкой в карточке, в форме его не поменять
      if (!track) {
        this.$nextTick(() => this.$refs.tracks.scrollIntoView({behavior: 'smooth', block: 'center'}))
        return
      }
      this.selectedTrack = track
      this.showRegistrationForm = true
    },
    onRegistrationCancel() {
      this.showCancelConfirmModal = true
    },
    onCancelConfirmYes() {
      this.showCancelConfirmModal = false
      this.showRegistrationForm = false
    },
    onCancelConfirmNo() {
      this.showCancelConfirmModal = false
    },
    onRegistrationSuccess(formData) {
      this.showRegistrationForm = false
      this.successEmail = formData.email
      // Новому пользователю нужно подтвердить почту по ссылке из письма, у авторизованного аккаунт уже активен
      this.successTitle = this.$authCheck()
          ? 'Письмо с инструкцией участника олимпиады направлено на адрес'
          : 'Для завершения регистрации на олимпиаду вам необходимо пройти по ссылке, которая направлена на адрес'
      this.showSuccessModal = true
    },
    onSuccessOk() {
      this.showSuccessModal = false
    },
    checkStartMode() {
      if (this.$route.query.step === 'start') {
        this.openStart()
      }
    },
    async openStart() {
      this.showStartModal = true
      if (!this.$authCheck()) {
        this.startState = {status: 'not_authenticated'}
        return
      }
      this.startLoading = true
      try {
        const res = await ApiService.get('olympiad/start')
        this.startState = res && res.data ? res.data : {status: 'error'}
      } catch (error) {
        this.startState = {status: 'error'}
      } finally {
        this.startLoading = false
      }
    },
    onStartLogin() {
      // После входа вернем участника на стартовый экран
      localStorage.setItem('redirectAfterLogin', '/olympics?step=start')
      this.$router.push('/sign-in').catch(() => {})
    },
    onStartRegister() {
      this.openRegistration(null)
    }
  }
}
</script>
<style>
.olympic-modal .modal-form {
  display: block!important;
}

</style>